import APITemplate from '@/api/APITemplate'

const url = '/api/restricted-area'

const template = APITemplate(url)
export default {
  ...template
}
